import { useState, useEffect } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/b56ddf5676badcd01c30e06215815ec0/37b9a51629d81ba8d66d9729e868ebad.png';

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? 'bg-[#FAF8F5]/95 backdrop-blur-sm shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between px-6 md:px-12 h-20">
        {/* Logo */}
        <a
          href="/"
          className="flex items-center gap-3 cursor-pointer"
          aria-label="Brand New You Home"
        >
          <div className="w-12 h-12 flex items-center justify-center">
            <img
              src={LOGO_URL}
              alt="Brand New You Logo"
              className="w-12 h-12 object-contain"
            />
          </div>
          <span
            className={`font-bold text-lg hidden sm:block transition-colors duration-300 ${
              scrolled ? 'text-[#2C2C2C]' : 'text-white'
            }`}
            style={{ fontFamily: '\'Playfair Display\', serif' }}
          >
            Brand New You
          </span>
        </a>

        {/* Desktop Nav Links */}
        <div className="hidden md:flex items-center gap-8">
          {[
            { label: 'About', id: 'solution' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'Benefits', id: 'benefits' },
            { label: 'Contact', id: 'consultation' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap hover:text-[#D4896A] ${
                scrolled ? 'text-[#2C2C2C]' : 'text-white'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* CTA Button */}
        <div className="flex items-center gap-4">
          <button
            onClick={() => scrollTo('consultation')}
            className="hidden md:block bg-[#D4896A] text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#c07a5a] transition-colors duration-300 cursor-pointer whitespace-nowrap"
          >
            Free Consultation
          </button>
          {/* Mobile menu toggle */}
          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors ${
              scrolled ? 'text-[#2C2C2C]' : 'text-white'
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#FAF8F5] border-t border-[#E8E0D8] px-6 py-6 flex flex-col gap-5">
          {[
            { label: 'About', id: 'solution' },
            { label: 'How It Works', id: 'how-it-works' },
            { label: 'Benefits', id: 'benefits' },
            { label: 'Contact', id: 'consultation' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-left text-base font-medium text-[#2C2C2C] hover:text-[#D4896A] transition-colors cursor-pointer"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo('consultation')}
            className="bg-[#D4896A] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#c07a5a] transition-colors cursor-pointer whitespace-nowrap w-full"
          >
            Free Consultation
          </button>
        </div>
      )}
    </header>
  );
}
